import { ajax } from '@/util/ajax'
const BASE_URL = '/gateway/platform-lmsapi/payment'

const PaymentApi = {
  singleOperation (input, success, failure) {
    ajax.post(
      `${BASE_URL}/payment-plan-assigned/single`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getPaymentInstallmentAndActionByLoanId (input, success, failure) {
    ajax.get(
      `${BASE_URL}/installments-with-actions/list`,
      input,
      success,
      failure
    )
  },
  WASendFax (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/wa/send-fax`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  WASendAllFax (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/wa/send-all-fax`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  reassignmentLoan (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/collection-management/reassignment`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  getCollectionManagementLoanData (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/collection-management/loan`,
      input,
      success,
      failure
    )
  },
  getCollectionManagementQueueData (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/collection-management/queue`,
      input,
      success,
      failure
    )
  },
  getCollectionData (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/get/collection-data`,
      input,
      success,
      failure
    )
  },
  getCollectionProvider (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/get/collectionProvider`,
      input,
      success,
      failure
    )
  },
  initEmployerInfo (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/get/employerInfo`,
      input,
      success,
      failure
    )
  },
  updateEmployerInfoInPayment (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/update/employerInfo`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  updateWageAssignment (input, success, failure) {
    ajax.post(
      `${BASE_URL}/update/wageAssignment`,
      input,
      success,
      failure,
      { showLoading: true }
    )
  },
  checkWhetherUpdateWageAssignment (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/check/updateWageAssignment`,
      input,
      success,
      failure
    )
  },
  revokedAndCancel (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/revoked-and-cancel`,
      input,
      success,
      failure
    )
  },
  getIsRevoked (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/get-is-revoked`,
      input,
      success,
      failure
    )
  },
  deleteNote (input, success, failure) {
    return ajax.delete(
        `${BASE_URL}/sys-log/delete/${input}`,
        null,
        success,
        failure
    )
  }
}
export { PaymentApi }
